import React from "react";
import { Box, Typography, Divider, Chip } from "@mui/material";

export default function MessageViewer({ selected, filter, insideCase }) {
  const fromName =
    `${selected?.from_relation?.name || ""} ${selected?.from_relation?.surname || ""}`.trim();
  const toName =
    `${selected?.to_relation?.name || ""} ${selected?.to_relation?.surname || ""}`.trim();
  const hasValidCaseId = (() => {
    const value = selected?.case_id;
    if (value === null || value === undefined || value === "") return false;
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0;
  })();

  const isCrmCaseMessage = insideCase && !toName;

  const fallbackFrom = "Enviado desde el CRM";
  const fallbackTo = insideCase ? "Mensaje del expediente" : "CRM";

  return (
    <Box sx={{ width: "100%" }}>
      {!insideCase && (
        <Box mb={1}>
          <Chip
            size="small"
            label={selected?.scope_chip_label || "Correo normal"}
            sx={{
              borderRadius: "8px",
              backgroundColor: hasValidCaseId ? "#d8ebff" : "#ececec",
              color: "#27446b",
              fontWeight: 600,
            }}
          />
        </Box>
      )}

      <Box display="flex" justifyContent="flex-end" mb={1}>
        <Typography variant="caption">{selected?.date}</Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Typography variant="h5" fontWeight={700} mb={1}>
        {selected?.subject}
      </Typography>

      <Divider sx={{ mb: 2 }} />

      <Box mb={3}>
        {isCrmCaseMessage ? (
          <Chip
            size="small"
            label="Mensaje del CRM"
            sx={{
              borderRadius: "8px",
              backgroundColor: "#ececec",
              color: "#27446b",
              fontWeight: 600,
            }}
          />
        ) : insideCase ? (
          <Box>
            <Typography>
              <strong>De:</strong> {fromName || fallbackFrom}
            </Typography>
            <Typography>
              <strong>Para:</strong> {toName || fallbackTo}
            </Typography>
          </Box>
        ) : filter === "sent" ? (
          <Typography>
            <strong>Para:</strong> {toName || fallbackTo}
          </Typography>
        ) : (
          <Typography>
            <strong>De:</strong> {fromName || fallbackFrom}
          </Typography>
        )}
      </Box>

      <Divider sx={{ mb: 3 }} />

      <Box
        sx={{ lineHeight: 1.7 }}
        dangerouslySetInnerHTML={{ __html: selected?.message }}
      />
    </Box>
  );
}
